var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGradientWhitePosts = function SvgGradientWhitePosts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.587 13.503 4.874-6.5a.703.703 0 0 1 1.125 0l4.875 6.5c.426.569-.164 1.339-.824 1.075l-4.352-1.741a.703.703 0 0 0-.523 0l-4.352 1.74c-.66.265-1.25-.505-.823-1.074Z",
    fill: "url(#gradient-white-posts_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m6.438.961-6.073 9.11c-.362.543.147 1.244.775 1.067l5.693-1.6a.703.703 0 0 1 .38 0l5.693 1.6c.629.177 1.138-.524.776-1.067L7.608.961a.703.703 0 0 0-1.17 0Zm.585 2.979a.771.771 0 1 0 0-1.543.771.771 0 0 0 0 1.543Z",
    fill: "url(#gradient-white-posts_svg__b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-white-posts_svg__a",
    x1: 0.082,
    y1: 6.253,
    x2: 8.626,
    y2: 19.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-white-posts_svg__b",
    x1: 7.023,
    y1: 0.648,
    x2: 7.064,
    y2: 14.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })))));
};

export default SvgGradientWhitePosts;